import { useLayoutEffect, useRef, useState } from "react";

export function MicroRoot({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState<number>(0);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    let raf = 0;

    const update = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const top = el.getBoundingClientRect().top; // lo que ocupa el host por arriba
        const h = Math.max(0, window.innerHeight - top);
        setHeight(h);
      });
    };

    update();

    // Si el host puede scrollear, el "top" cambia: escuchamos scroll + resize
    window.addEventListener("resize", update, { passive: true });
    window.addEventListener("scroll", update, { passive: true });

    return () => {
      cancelAnimationFrame(raf);
      window.removeEventListener("resize", update);
      window.removeEventListener("scroll", update);
    };
  }, []);

  return (
    <div
      id="mro-carros-de-motor"
      ref={ref}
      style={{ height: height ? `${height}px` : undefined }}
      className="mro-carros-de-motor w-full min-h-0 overflow-hidden"
    >
      {children}
    </div>
  );
}
